import Popular from '../../images/popular.png'
import Photo from '../../images/photo.png'
import Images from '../../images/images.png'
import Dubai from '../../images/smoldubay.svg'
import SriLanka from '../../images/smolsrilanka.svg'
import Egypt from '../../images/smolegypt.svg'
import Moldiv from '../../images/smolMoldiv.svg'
import Thailind from '../../images/smolthailind.svg'
import Georgia from '../../images/smolGeorgia.svg'
import Europe from '../../images/smolEur.svg'
import Cypros from '../../images/smolcypros.svg'
import {useState} from "react";
import classNames from "../../utils";
import { Link as ScrollLink } from 'react-scroll'; // Import as ScrollLink

const BlockThree = () => {
  const [name, setName] = useState('Egypt')

  const countriesData = [
    {title: 'Egypt', icon: Egypt, href: 'Egypt'},
    {title: 'Sri Lanka', icon: SriLanka, href: 'SriLanka'},
    {title: 'Dubai', icon: Dubai, href: 'Dubai'},
    {title: 'Cyprus', icon: Cypros, href: 'Cyprus'},
    {title: 'Thailand', icon: Thailind, href: 'Thailand'},
    {title: 'Maldives', icon: Moldiv, href: 'Maldives'},
    {title: 'Georgia', icon: Georgia, href: 'Georgia'},
    {title: 'Europe', icon: Europe, href: 'Europe'},
  ]

  const active = (title) => {
    setName(title)
  }

  return (
    <>
      <div className="my-[30px] md:my-[64px] flex justify-around flex-col sm:flex-row items-center">
        <div className="flex items-start md:items-baseline">
          <img className="w-[250px] lg:w-[400px]" alt="png" src={Popular} />
          <img className="w-[50px] md:w-[90px] h-[40px] md:h-[80px]" alt="png" src={Photo} />
        </div>
        <img className="max-w-[250px] md:max-w-[500px] ml-[40px] md:ml-0" alt="png" src={Images} />
      </div>
      <div className="px-6 md:px-16">
        <div className="w-full rounded-xl max-h-full lg:max-h-[100px] h-full lg:h-[100px] my-20 flex flex-col lg:flex-row justify-between bg-[#F6F6F6] z-40 relative">
          {countriesData.map((item,index) => {
            const isFirst = index === 0;
            const isLast = index === countriesData.length - 1;
            return (
              <ScrollLink
                smooth={true}
                offset={-70}
                key={item.href}
                to={item.href}
                duration={500} className="h-full">
                  <div onClick={() => active(item.title)} className={classNames('flex items-center gap-x-2 py-2 px-2 cursor-pointer h-full', name === item.title ? 'gradient-box' : 'bg-[#F6F6F6]',(isFirst || isLast) ? 'rounded-xl' : '' )}>
                    <img alt={item.title} src={item.icon} />
                    <p className="font-customFont text-[#756E80] text-2xl">{item.title}</p>
                  </div>
              </ScrollLink>
            )
          })}
        </div>
      </div>
    </>
  );
}

export default BlockThree;
